var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConnection = function SvgConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 17.25H3V21h3v-3.75ZM7.5 21A1.5 1.5 0 0 1 6 22.5H3A1.5 1.5 0 0 1 1.5 21v-3.75a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5V21Zm7.5 0V10.5A1.5 1.5 0 0 0 13.5 9h-3A1.5 1.5 0 0 0 9 10.5V21a1.5 1.5 0 0 0 1.5 1.5h3A1.5 1.5 0 0 0 15 21Zm1.5 0a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 21 1.5h-3A1.5 1.5 0 0 0 16.5 3v18Zm-3-10.5h-3V21h3V10.5ZM21 3h-3v18h3V3Z"
  })));
};
export default SvgConnection;